import { isSupportedAlpha2CountryCode } from '@/lib/utils/localization/isSupportedAlpha2CountryCode'
import { toAlpha3 } from '@/lib/utils/localization/toAlpha3'

export type GetSocialMediaIconsProps = {
  locale: string
}

export type CosmicSocialMediaIcons = {
  title: string
  link: { url: string; target: string }
  logo: { url: string }
}

export type CosmicErrorResponse = {
  error: {
    code: 'COSMIC_ICON_DATA_MISSING'
    message: string
    source: 'cosmic'
    timestamp: string
  }
}

export type CosmicSocialMediaIconsResponse = {
  locales: Array<{
    locale: string
    channels: CosmicSocialMediaIcons[]
  }>
}

export type CosmicSocialMediaIconsResult =
  | CosmicSocialMediaIcons[]
  | CosmicErrorResponse
  | null

export const getCosmicSocialMediaIcons = async ({
  locale,
}: GetSocialMediaIconsProps): Promise<CosmicSocialMediaIconsResult> => {
  const alpha2CountryCode = locale.split('-')[1]

  if (!isSupportedAlpha2CountryCode(alpha2CountryCode)) return null

  const alpha3CountryCodeUpperCased = toAlpha3(
    alpha2CountryCode,
  ).toUpperCase() as Uppercase<ReturnType<typeof toAlpha3>>

  const url = `${process.env.NEXT_PUBLIC_COSMIC_BASE_URL}/footers/socialMedia/published?siteAlias=${process.env.NEXT_PUBLIC_COSMIC_SITE_ALIAS}&countryAlias=${alpha3CountryCodeUpperCased}&locale=${locale}`

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      accept: '*/*',
    },
  })
  if (!response.ok) {
    return {
      error: {
        code: 'COSMIC_ICON_DATA_MISSING',
        message:
          'We were unable to load the social icons. Please try refreshing the page.',
        source: 'cosmic',
        timestamp: new Date().toISOString(),
      },
    }
  }
  const data = (await response.json()) as CosmicSocialMediaIconsResponse
  const socialMediaIcons = data.locales[0].channels
  return socialMediaIcons
}
